<template>
    <Invoice :kind="2"></Invoice>
</template>

<script>
import Invoice from './Invoice';
export default {
    name: "DispersedExpendInvoice",
    components: { Invoice }
}
</script>
